import React from 'react';
import './App.css';
import LoadingWapper from './views/LoadingWapper';

function App() {
  return (
    <LoadingWapper/>
  );
}

export default App;
